import hateoas from 'viralstyle-ui/src/hateoas';
import clone from 'lodash/clone';
import isEqual from 'lodash/isEqual';

import router from '@/router';

const SIZE = 12;

export const getCollection = async ({ rootState, state, dispatch, commit }, currentSlug) => {
  if (currentSlug !== state.currentSlug) {
    commit('updateState', { object: state, property: 'currentSlug', value: currentSlug });

    let publicName = rootState.route.params.publicName,
      slug = rootState.route.params.collectionSlug,
      page = rootState.route.params.page,
      response;

    if (rootState.isWhitelabel) {
      publicName = rootState.domainConfig.public_name;
    }

    response = await dispatch('get', hateoas.url('get_client_store', { publicName, slug }));

    commit('updateCollection', response);

    response = await dispatch('lazyLoadCollectionCampaigns', page);

    dispatch('getCollectionPartnerInfo');

    return response;
  }
};

export const lazyLoadCollectionCampaigns = async ({ rootState, state, getters, dispatch, commit }, page) => {
  let publicName = rootState.route.params.publicName,
    slug = rootState.route.params.collectionSlug,
    from = page * SIZE,
    apiParams = [],
    query = clone(rootState.route.query),
    routePayload;

  if (rootState.isWhitelabel) {
    publicName = rootState.domainConfig.public_name;
  }

  apiParams.push(`page=${page - 1}`);
  apiParams.push(`limit=${SIZE}`);
  apiParams.push('search=true');

  if (state.selectedProductType && state.selectedProductType !== '0') {
    apiParams.push(`filters[]=product_type:${state.selectedProductType}`);

    query.product_type = state.selectedProductType;
  } else {
    delete query.product_type;
  }

  if (state.info.enable_sort_and_filter) {
    apiParams.push(`sort=${state.selectedSort}`);
  } else {
    apiParams.push(`sort=${getters.defaultSort}`);
  }

  if (getters.collectionSelectedSortText !== 'Newest First') {
    query.sort = getters.collectionSelectedSortText;
  } else {
    delete query.sort;
  }

  routePayload = { name: 'collection', params: { page: page.toString() }, query };

  if (!isEqual(query, rootState.route.query) || page !== rootState.route.params.page) {
    if (rootState.route.name === 'collection') {
      router.replace(routePayload);
    } else {
      router.push(routePayload)
    }
  }

  let response = await dispatch('get', `${hateoas.url('get_client_store_campaigns', { publicName, slug })}?${apiParams.join('&')}`);

  commit('updateCollectionCampaigns', response.data._embedded.items);

  commit('updateState', { object: state, property: 'maxPages', value: Math.ceil(response.data.total_results / SIZE) });

  return response;
};

export const getCollectionFilters = async ({ rootState, state, dispatch, commit }) => {
  if (!state.categories || !state.productTypes) {
    let publicName = rootState.route.params.publicName,
      slug = rootState.route.params.collectionSlug;

    if (rootState.isWhitelabel) {
      publicName = rootState.domainConfig.public_name;
    }

    let response = await dispatch('get', hateoas.url('get_store_filters', { publicName, slug }));

    commit('updateState', { object: state, property: 'productTypes', value: response.data.categories });

    return response;
  }
};

export const recordCollectionVisit = ({ state, dispatch }) => {
  dispatch('post', { apiUrl: state.info._links.record_visit.href });
};

export const getCollectionPartnerInfo = async ({ state, dispatch, commit }) => {
  if (state.info && state.info._links.cobrand_partner_configs.href) {
    let response = await dispatch('get', state.info._links.cobrand_partner_configs.href);

    commit('setCollectionPartnerInfo', response.data);
  }
};